//@flow strict

import * as React from 'react';
import {SUPPORTED_LANGUAGES} from 'src/constants/language-support';
import useI18n from 'src/hooks/useI18n';


export const isLanguageSupported = (language: string): boolean => {
  return SUPPORTED_LANGUAGES.includes(language);
};

// using HOC to inject the `t` function into the class component
// $FlowFixMe[signature-verification-failure]
export function withI18n(Component) {
  return function WrapperComponent(props) {
    const {labelI18nInstance} = useI18n();
    return <Component {...props} t={labelI18nInstance.t} />;
  };
}
